import { Button } from '@/components/ui/Button'
import { Compass, Link2 } from '@/lib/icons'

export function Hero() {
  return (
    <section
      aria-labelledby="hero-heading"
      className="relative isolate flex flex-col items-center gap-8 py-12 text-center md:py-20"
    >
      <div
        aria-hidden="true"
        className="bg-hero-glow pointer-events-none absolute inset-x-0 -top-24 -z-10 h-[520px] blur-3xl"
      />

      <div className="relative z-10 max-w-3xl space-y-6">
        <h1
          id="hero-heading"
          className="text-headline-lg text-fg md:text-display-xl text-balance"
        >
          <span className="block">About to buy?</span>
          <span className="text-gradient block">Check dizcant first.</span>
        </h1>
        <p className="font-body text-body-md text-fg-muted md:text-body-lg mx-auto max-w-2xl text-pretty">
          Real referral and discount links, posted by people who actually used
          them — each one checked, dated, and gone the moment it expires.
        </p>
      </div>

      <div className="relative z-10 mt-2 flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
        <Button
          href="/discover"
          variant="gradient"
          size="lg"
          className="w-full sm:w-auto"
        >
          <Compass className="size-5" aria-hidden="true" />
          Browse live links
        </Button>
        <Button
          href="/drop"
          variant="secondary"
          size="lg"
          className="w-full sm:w-auto"
        >
          <Link2 className="size-5" aria-hidden="true" />
          Post a link
        </Button>
      </div>
    </section>
  )
}
